import React, { useEffect, useState, useRef, useContext } from 'react';
import { GetDomain, RemoveCookie, GetCoockie, FormatCurrency, CheckSession, GetShoppingCart } from "../GlobalScript";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
import $ from 'jquery';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ProgressBar from 'react-bootstrap/ProgressBar';
import PulseLoader from "react-spinners/PulseLoader";
import Modal from 'react-bootstrap/Modal';
import FooterDealer from '../FooterDealer.js';
import { ShoppingCartContext } from './ShoppingCartContext';

export default function KLoyalty() {

    const [UserInfo, setUserInfo] = useState(null);
    const [Year, setYear] = useState(null);
    const [pop, setPop] = useState(true);

    const handlePop = () => setPop(true);
    const handleClose = () => setPop(false);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);

    useEffect(() => {
        setShoppingCart(GetShoppingCart(shoppingCart));     
        document.title = 'K-Dealer - My K-Loyalty';
    }, []);

    useEffect(() => {
        CheckSession();
        if (!UserInfo) {
            let ck = GetCoockie();
            setUserInfo(ck);
            window.GlobalLoading++;
        }
        if (window.GlobalLoading === 1) {
            window.location.reload();
        }
    }, [UserInfo])

    const TierLogo = [
        <div className="svg-holder">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 23.3 22.7" className="tier-svg-small mb-half">
                <path className="st0 base" d="M11.7,0C5.4,0,.3,5.1.3,11.4s5.1,11.4,11.4,11.4,11.4-5.1,11.4-11.4S18,0,11.7,0ZM16.4,18.6l-4.7-2.6-4.7,2.6,1-5.3-3.9-3.7,5.3-.7,2.3-4.8,2.3,4.8,5.3.7-3.9,3.7,1,5.3Z" />
            </svg>
        </div>,
        <div className="svg-holder">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 23.3 22.7" className="tier-svg-small mb-half">
                <path className="st0 silver" d="M11.7,0C5.4,0,.3,5.1.3,11.4s5.1,11.4,11.4,11.4,11.4-5.1,11.4-11.4S18,0,11.7,0ZM16.4,18.6l-4.7-2.6-4.7,2.6,1-5.3-3.9-3.7,5.3-.7,2.3-4.8,2.3,4.8,5.3.7-3.9,3.7,1,5.3Z" />
            </svg>
        </div>,
        <div className="svg-holder">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 23.3 22.7" className="tier-svg-small mb-half">
                <path className="st0 gold" d="M11.7,0C5.4,0,.3,5.1.3,11.4s5.1,11.4,11.4,11.4,11.4-5.1,11.4-11.4S18,0,11.7,0ZM16.4,18.6l-4.7-2.6-4.7,2.6,1-5.3-3.9-3.7,5.3-.7,2.3-4.8,2.3,4.8,5.3.7-3.9,3.7,1,5.3Z" />
            </svg>
        </div>,
        <div className="svg-holder">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 23.3 22.7" className="tier-svg-small mb-half">
                <path className="st0 green" d="M11.7,0C5.4,0,.3,5.1.3,11.4s5.1,11.4,11.4,11.4,11.4-5.1,11.4-11.4S18,0,11.7,0ZM16.4,18.6l-4.7-2.6-4.7,2.6,1-5.3-3.9-3.7,5.3-.7,2.3-4.8,2.3,4.8,5.3.7-3.9,3.7,1,5.3Z" />
            </svg>
        </div>
    ]

    const GetTiersInfo = (type) => {
        try {
            if (UserInfo) {
                //let info = TierInfo[type - 1];
                const infoFromAPI = UserInfo.tiers.length >= type ? UserInfo.tiers[type - 1] : null;
                if (infoFromAPI) {
                    return <Col sm={12} className={"text-center loyalty-progress " + infoFromAPI.currentTierLimitName.toLowerCase()}>
                        <div className="svg-row">
                            <h4 className="header white-text font-normal mt-2">{infoFromAPI.currentTierLimitName.toUpperCase()}</h4>
                            {TierLogo[infoFromAPI.currentTierType]}
                        </div>
                        <ProgressBar now={infoFromAPI.percentToNextTier} />
                        {infoFromAPI.percentToNextTier === 100 ? <p>Congratulations <br /> You've achieved the highest tier!</p> :
                            <p>{FormatCurrency(infoFromAPI.valueToNextTier)} to {FormatCurrency(infoFromAPI.nextTierLimitName)}</p>
                        }

                    </Col>
                }
            }
        } catch (e) {

        }
    }

    const GetNextLevelMsg = (type) => {
        try {
            if (UserInfo) {
                const infoFromAPI = UserInfo.tiers.length >= type ? UserInfo.tiers[type - 1] : null;
                if (infoFromAPI) {
                    if (infoFromAPI.percentToNextTier === 100) {
                        return "Congratulations, you've achieved the highest tier!";
                    } else {
                        return FormatCurrency(infoFromAPI.valueToNextTier) + " to " + FormatCurrency(infoFromAPI.nextTierLimitName);
                    }
                }
            }
        } catch (e) {

        }
    }

    const LoadInfo = async () => {
        try {
            CheckSession();
            let ck = GetCoockie();

            if (ck && ck.dealerID) {
                const response = await fetch("kdealer/GetTierinfo/" + ck.dealerID);
                if (response.status !== 200) {
                    return;
                }
                const js = await response.json();
                setUserInfo(js);
                console.log(js);
                if (js.loyaltyInternals.length > 0 && js.loyaltyInternals[0].year) {
                    setYear(js.loyaltyInternals[0].year);
                }
            }
            handleClose();
        } catch (e) {
            console.log(e);
            handleClose();
            return;
        }
    }

    useEffect(() => {
        LoadInfo();
    }, [GetCoockie])

    return (
        <>
            {UserInfo ?
                <div className="full-width">
                    <Container className="checkout-container main-container dealer-section">

                        <Row className="help-title-row checkout-title-row">
                            <Col className="help-center-title checkout-title">
                                <h1 className="heading help-heading">MY K-LOYALTY</h1>
                            </Col>
                            <Col className="checkout-title-under">
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={12}>
                                <Card className="help-card loyalty-first-cards">
                                    <Card.Body>
                                        <Row className="gy-3">
                                            <Col md={6} lg={3}>
                                                <Card className="green-bg">
                                                    <Card.Body>
                                                        <Row>
                                                            <Col sm={12} className="mt-3 text-center">
                                                                <h3 className="heading">CURRENT TIER:</h3>
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            {UserInfo && UserInfo.currentLevel && 
                                                                <Col sm={12} className="mt-1 text-center">
                                                                    <div className="svg-row">
                                                                        <h1 className="white-text heading">{UserInfo.currentLevel.toUpperCase()}</h1>

                                                                        <div className="svg-holder">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 23.3 22.7" className="tier-svg">
                                                                                <path className={"st0 " + UserInfo.currentLevel.toLowerCase()} d="M11.7,0C5.4,0,.3,5.1.3,11.4s5.1,11.4,11.4,11.4,11.4-5.1,11.4-11.4S18,0,11.7,0ZM16.4,18.6l-4.7-2.6-4.7,2.6,1-5.3-3.9-3.7,5.3-.7,2.3-4.8,2.3,4.8,5.3.7-3.9,3.7,1,5.3Z" />
                                                                            </svg>
                                                                        </div>
                                                                    </div>
                                                                </Col>
                                                            }                                                           
                                                        </Row>

                                                        <Row>
                                                            <Col sm={12} className="mt-2 text-center">
                                                                <h3 className="heading">SALES DISCOUNT:</h3>
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col sm={12} className="text-center">
                                                                <h3 className="white-text heading mb-0">{UserInfo.currentLevelDiscountPercent}%</h3>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>

                                                    <Card.Footer className="white-bg">
                                                        <Row>
                                                            <Col sm={12} className="mt-2 text-center">
                                                                <h4 className="heading">NEXT MONTH'S TIER</h4>

                                                                {UserInfo && UserInfo.currentLevel && UserInfo.nextMonthTier &&
                                                                    <>
                                                                        <div className="svg-row">
                                                                            {UserInfo.nextMonthTierChange !== 0 && 
                                                                                <div className="svg-holder mr-2">
                                                                                    {UserInfo.nextMonthTierChange < 0 ?
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-down-fill red tier-svg-small ml-0" viewBox="0 0 16 16">
                                                                                            <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                                                                        </svg>
                                                                                        :
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-up-fill green tier-svg-small ml-0" viewBox="0 0 16 16">
                                                                                            <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
                                                                                        </svg>
                                                                                    }
                                                                                </div>
                                                                            }

                                                                        <h4 className={`heading ${UserInfo.nextMonthTierChange < 0 ? "red" : UserInfo.nextMonthTierChange > 0 && "green"}`}>{UserInfo.nextMonthTier.toUpperCase()}</h4>
                                                                        </div>

                                                                        {UserInfo.bellowThreshold &&
                                                                            <p className="mb-0 red mt-2">
                                                                                {UserInfo.bellowThreshold} are below the threshold. Increase {UserInfo.bellowThreshold} this month to
                                                                                maintain your {UserInfo.currentLevel.toUpperCase()} tier.
                                                                            </p>
                                                                        }
                                                                    </>
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </Card.Footer>
                                                </Card>
                                            </Col>

                                            <Col md={6} lg={3} className="loyalty-cards">
                                                <Card>
                                                    <Card.Body className="align-content-center">
                                                        <Row>
                                                            <Col sm={3} className="g-0">
                                                                <div className="dealer-card">
                                                                    <div className="svg-holder">
                                                                        <img src="../../../Images/icon-total-parts-accessories.svg" alt="" className="" />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col sm={9}>
                                                                <p className="mb-0 bold">Total Gross Sales</p>
                                                                <p className="mb-0">(Parts & Accessories)</p>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>

                                                    <Card.Footer className="black-bg">
                                                        <Row>
                                                            {GetTiersInfo(1)}
                                                        </Row>
                                                    </Card.Footer>
                                                </Card>
                                            </Col>

                                            <Col md={6} lg={3} className="loyalty-cards">
                                                <Card>
                                                    <Card.Body className="align-content-center">
                                                        <Row>
                                                            <Col sm={3} className="g-0">
                                                                <div className="dealer-card">
                                                                    <div className="svg-holder">
                                                                        <img src="../../../Images/icon-oils-quart.svg" alt="" className="" />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col sm={9}>
                                                                <p className="mb-0 bold">Oils / Chemicals / Lubricants</p>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>

                                                    <Card.Footer className="black-bg">
                                                        <Row>
                                                            {GetTiersInfo(2)}
                                                        </Row>
                                                    </Card.Footer>
                                                </Card>
                                            </Col>

                                            <Col md={6} lg={3} className="loyalty-cards">
                                                <Card>
                                                    <Card.Body className="align-content-center">
                                                        <Row>
                                                            <Col sm={3} className="g-0">
                                                                <div className="dealer-card">
                                                                    <div className="svg-holder">
                                                                        <img src="../../../Images/apparel.svg" alt="" className="" />
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                            <Col sm={9}>
                                                                <p className="mb-0 bold">Apparel / Gifts</p>
                                                            </Col>
                                                        </Row>
                                                    </Card.Body>

                                                    <Card.Footer className="black-bg">
                                                        <Row>
                                                            {GetTiersInfo(3)}
                                                        </Row>
                                                    </Card.Footer>
                                                </Card>
                                            </Col>

                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col sm={12}>
                                <div className="card-tab-title">
                                    <h5>TIER TRACKER *</h5>
                                </div>
                                <Card>
                                    {UserInfo && UserInfo.tiers && <Card.Body className="order-table">
                                        <Table hover responsive bordered>
                                            <thead>
                                                <tr>
                                                    <td></td>
                                                    <th>TIER</th>
                                                    <th>SHIPPED</th>
                                                    <th>RETURNED</th>
                                                    <th>TOTAL</th>
                                                    <th>PROGRESS TO NEXT TIER</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left bold">Total Gross Sales <br /> (Parts & Accessories)</td>
                                                    <td>{UserInfo.tiers[0].currentTierLimitName}</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[0].shippedAmount)}</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[0].returnAmount)}</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[0].currentValue)}</td>
                                                    <td>{GetNextLevelMsg(1)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left bold">Oils / Chemicals / <br /> Lubricants</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[1].currentTierLimitName)}</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[1].shippedAmount)}</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[1].returnAmount)}</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[1].currentValue)}</td>
                                                    <td>{GetNextLevelMsg(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-left bold">Apparel / Gifts</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[2].currentTierLimitName)}</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[2].shippedAmount)}</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[2].returnAmount)}</td>
                                                    <td>{FormatCurrency(UserInfo.tiers[2].currentValue)}</td>
                                                    <td>{GetNextLevelMsg(3)}</td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Card.Body>}
                              
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col sm={12}>
                                <div className="card-tab-title">
                                    <h5>MONTHLY PURCHASE HISTORY **</h5>
                                </div>
                                <Card>
                                    <Card.Body className="order-table">
                                        {Year &&
                                            <Table hover responsive bordered>
                                                <thead>
                                                    <tr>
                                                        <td></td>
                                                        {UserInfo.dateNames && UserInfo.dateNames.map((item, index) => (
                                                            /* <th>{Year} <br /> JAN</th>*/
                                                            <th key={"th" + index}>{item}</th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                {UserInfo.loyaltyInternals &&
                                                    <tbody>
                                                        <tr>
                                                            <td className="text-left bold">Total Gross Sales <br /> (Parts & Accessories)</td>
                                                            {UserInfo.loyaltyInternals && UserInfo.loyaltyInternals.length > 0 && UserInfo.loyaltyInternals[0].value.map((item, index) => (
                                                                <td key={UserInfo.loyaltyInternals[0].year + index}>{item ? item : '$0.00'}</td>
                                                            ))}
                                                        </tr>
                                                        <tr>
                                                            <td className="text-left bold">Oils / Chemicals / <br /> Lubricants</td>
                                                            {UserInfo.loyaltyInternals && UserInfo.loyaltyInternals.length > 1 && UserInfo.loyaltyInternals[1].value.map((item, index) => (
                                                                <td key={UserInfo.loyaltyInternals[1].year + index}>{item ? item : '$0.00'}</td>
                                                            ))}
                                                        </tr>
                                                        <tr>
                                                            <td className="text-left bold">Apparel / Gifts</td>
                                                            {UserInfo.loyaltyInternals && UserInfo.loyaltyInternals.length > 2 && UserInfo.loyaltyInternals[2].value.map((item, index) => (
                                                                <td key={UserInfo.loyaltyInternals[2].year + index}>{item ? item : '$0.00'}</td>
                                                            ))}
                                                        </tr>
                                                    </tbody>}

                                            </Table>
                                        }

                                        <Row className="mt-4">
                                            <Col sm={4}>
                                                <p><a href="/downloads/LoyaltyProgramFlyer.pdf" target="_blank" className="black-text">K-Loyalty Program Information and Freight Policy</a></p>
                                            </Col>
                                            <Col sm={4}>
                                                <p><a href="/downloads/KLoyaltyVideo.mp4" target="_blank" className="black-text">K-Loyalty Tutorial Video</a></p>
                                            </Col>
                                        </Row>

                                        <p className="red mt-3">
                                            * Twelve-Month Rolling K-Loyalty Tier Tracker is a daily overview of your sales and returns in the three qualifying categories. Data is updated as an
                                            overnight process. K-Loyalty tiers update on the first of every month
                                        </p>

                                        <p className="red">
                                            ** Twelve-month Purchasing tracker displays your dealerships month-by-month P&A purchasing from KMC
                                        </p>

                                        <p className="red">
                                            *** Last twelve full months
                                        </p>

                                        <p className="red">
                                            **** Last eleven months, plus current month-to-date
                                        </p>

                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Container>

                    <FooterDealer />
                </div>
                :
                <>
                    <Modal className="loader-div" id="loader" show={pop} onHide={handleClose} size="lg" centered>
                        <PulseLoader color="#66cc33" size="20px" margin="12px" />
                    </Modal>
                </>
            }
            <Container className="">
                <Row>
                </Row>
            </Container>
        </>
    );
}